import { VEHICLE_TYPE } from "../constants/enum";

/**
 * Returns a human-readable, correctly capitalized label for a vehicle type.
 * @param type The vehicle type enum value
 * @returns A capitalized label (e.g., "Car", "Bike", "E-Bike")
 */
export const getVehicleTypeLabel = (type: number | string): string => {
  const numericType = Number(type);
  switch (numericType) {
    case VEHICLE_TYPE.CAR:
      return "سيارة / Car";
    case VEHICLE_TYPE.BIKE:
      return "دراجة / Bike";
    case VEHICLE_TYPE.BICYCLE:
      return "دراجة كهربائية / E-Bike";
    case VEHICLE_TYPE.CARAVAN:
      return "كرفان / Caravan";
    case VEHICLE_TYPE.TRUCK:
      return "معدات ثقيلة / Heavy Equipment";
    case VEHICLE_TYPE.HEAVY_VEHICLE:
      return "معدات ثقيلة (إيجار) / Heavy Equipment (Rental)";

    default:
      // Fallback: If it's a key name (unlikely but possible), try to format it
      if (typeof type === "string" && isNaN(numericType)) {
        return type
          .replace(/_/g, " ")
          .toLowerCase()
          .replace(/\b\w/g, (c) => c.toUpperCase());
      }
      return "";
  }
};
